// Public surface of the DXF export. `buildDxf` is a pure builder with an
// injected asset loader (headless-testable); `downloadDxf` wires it to fetch +
// a browser download and returns the warnings for the caller to surface.

import { buildDxf } from './buildDxf';
import { encodeCp1252 } from './writer';

export { buildDxf, TEXT_CAP_RATIO, isDxfDesignNode } from './buildDxf';
export { sanitizeBlockName, formatReal, encodeCp1252, LAYER_SYMBOLS, LAYER_LABELS, LAYER_CONDUCTORS, LAYER_FRAME } from './writer';
export { svgToSymbolGeometry } from './svgSymbol';
export { edgeAnchor, edgeRoutePoints, nodeBox } from './anchors';

/** Browser asset loader using fetch. */
export const fetchAssetLoader = {
  async loadText(path) {
    const res = await fetch(path);
    return res.ok ? res.text() : null;
  },
};

/**
 * Build and download the DXF for a diagram. Returns the build warnings
 * (missing/unparseable SVGs, unroutable edges, …) so the UI can surface them.
 */
export async function downloadDxf(
  nodes,
  edges,
  width,
  height,
  filename = 'diagram.dxf',
  options = {},
) {
  const { dxf, warnings } = await buildDxf(nodes, edges, width, height, fetchAssetLoader, options);
  // R12 files are ANSI-codepage encoded (see $DWGCODEPAGE) — a UTF-8 blob would
  // mojibake accented labels in CAD apps.
  const blob = new Blob([encodeCp1252(dxf)], { type: 'application/vnd.dxf' });
  const url = URL.createObjectURL(blob);
  const link = window.document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
  return warnings;
}
